import { render, staticRenderFns } from "./v80a1030.vue?vue&type=template&id=0c800c79&scoped=true"
import script from "./v80a1030.vue?vue&type=script&lang=js"
export * from "./v80a1030.vue?vue&type=script&lang=js"
import style0 from "./v80a1030.vue?vue&type=style&index=0&id=0c800c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c800c79",
  null
  
)

export default component.exports